import React, {Component} from 'react'
import * as Sentry from '@sentry/browser'
import {Link} from 'react-router-dom'
import {Empty, Icon} from 'antd'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = {hasError: false}
  }
  static getDerivedStateFromError(error) { //eslint-disable-line no-unused-vars
    return {hasError: true}
  }
  componentDidCatch(error, errorInfo) {
    if (!process.env.SENTRY) {
      return
    }
    Sentry.withScope(scope => {
      for (let key in errorInfo) {
        scope.setExtra(key, errorInfo[key])
      }
      Sentry.captureException(error)
    })
  }
  retry = () => {
    if (this.props.retry) {
      this.props.retry()
    } else {
      window.location.reload()
    }
  }
  render() {
    if (this.state.hasError) {
      return(
        <Empty
          image={<Icon type='alert' style={{fontSize: 90}}/>}
          description={<span style={{fontSize: 22}}>Something broke</span>}
          style={{padding: 100}}
        >
          {
            this.props.message
            ||
            <span>You can go to <Link to='/'>Main page</Link> or <a onClick={this.retry}>retry</a></span>
          }
        </Empty>
      )
    }
    return this.props.children
  }
}

export function withBoundary(WrappedComponent) {
  return () => (
    <ErrorBoundary><WrappedComponent/></ErrorBoundary>
  )
}
